
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
/**
- Notice / Announcement Card with edge icon
- Icon position can be adjustable; .edge-icon > img
**/
export default Vue.extend<any, any, any, any>({
  name: 'NoticeCard',
  components: {
    EuCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set card elevation
     */
    elevation: {
      type: String,
      default: 'interactive'
    },
    /**
     * Set Title label
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set template in object form
     */
    template: {
      type: [Function, Object],
      default: () => {}
    },
    /**
     * Set edge icon
     */
    icon: {
      type: String,
      default: ''
    },
    /**
     * Set base color for the edge icon
     */
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    computedIconStyle(color: string) {
      return `background: ${color}`;
    },
    handleClick(e: any) {
      /**
       * Method when card is click
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
